import { render } from "./DashboardAddCollection.vue?vue&type=template&id=1bfa5b92"
import script from "./DashboardAddCollection.vue?vue&type=script&lang=js"
export * from "./DashboardAddCollection.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/donorsweb/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__